import { format, parseISO } from 'date-fns';
import { FunctionComponent, memo, useContext } from 'react';
import { EventDetailsModalContext } from '../../../../context';
import { Event } from '../../../../services';
import { getCssVar, getDateFnsLocale, getDayOfMonthFormat, IconLabel } from '../../../../shared';

import classes from './UpcomingEventCard.module.scss';

interface UpcomingEventCardProps {
  event: Event;
}

export const UpcomingEventCard: FunctionComponent<UpcomingEventCardProps> = memo(({ event }) => {
  const { name, startAt, id: eventId } = event;

  const { setEventDetailsModalData } = useContext(EventDetailsModalContext);

  return (
    <button
      type={'button'}
      className={classes['card']}
      onClick={() => setEventDetailsModalData({ eventId })}
    >
      <div className={classes['card__content']}>
        <div className={classes['card__content-date']}>
          {format(parseISO(startAt), `EEE ${getDayOfMonthFormat()} MMMM yyyy`, {
            locale: getDateFnsLocale(),
          })}
        </div>
        <div className={classes['card__content-title']}>{name}</div>
      </div>
      <IconLabel
        iconId={'arrow-right'}
        iconSize={16}
        color={getCssVar('--base-link-text-color')}
        singleColor
      />
    </button>
  );
});
